<template>
  <div class="home">
    <HeadBar title="证书下载" />
    <div class="box">
      <h4>
        {{searchResult.matchName}}
      </h4>
      <h5>
        {{searchResult.projectName}}
      </h5>
      <div v-if="searchResult && searchResult.url" class="item">
        <a :href="searchResult.url" target="_blank" rel="noopener noreferrer">
          <img :src="searchResult.url" alt="证书" class="news-image" />
        </a>
        <!-- @click="downImg(searchResult.url)" -->
        <p class="text-center mt10">
          <van-button type="danger" icon="down" size="mini">长按图片保存图片到手机</van-button>
        </p>
      </div>

      <div v-else class="empty">暂无证书</div>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import {
    fetchHttp,
    downloadIamge,
    getQueryString,
  } from "../util/fn.js";

  import { Toast, Button } from "vant";

  export default {
    name: "home",
    components: {
      HeadBar,
      [Button.name]: Button,
    },
    data() {
      return {
        searchResult: {},
      };
    },
    computed: {},
    mounted() {
      fetchHttp(
        "marathon/result/personalInformation",
        {
          userId: Cookies.get('USERID'),
          matchId: getQueryString("matchId"),
          projectId: getQueryString("projectId"),
        },
        "GET"
      ).then((res) => {
        if (res && res.code === 0) {
          this.searchResult = res.data;
        }
      });
    },
    methods: {
      downImg(img) {
        downloadIamge(img, "证书");
      },
    },
  };
</script>
<style scope lang="less">
  .box {
    color: #333;
  }

  .empty {
    margin-top: 30px;
  }

  .news-image {
    width: 100%;
    height: auto;
  }

  .match-list {
    margin: 0 10px;
  }

  .match-year {
    margin-bottom: 20px;
  }
</style>